/**
 * Application-wide constants
 */

// API Configuration
export const API_CONFIG = {
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'https://dev.api.arogyakhata.com',
  TIMEOUT: 30000,
};

// localStorage Keys — single source of truth for all storage keys
// NOTE: JWT tokens (idToken, accessToken, refreshToken) are stored as httpOnly cookies,
// NOT in localStorage. Only non-sensitive session metadata is kept here.
export const STORAGE_KEYS = {
  AGENT_TYPE: 'agentType',
  USER_ID: 'userId',
  USERNAME: 'username',
  DISPLAY_NAME: 'displayName',
  // EMAIL and PHONE intentionally removed — PII must not persist in localStorage.
  // Fetch from backend /api/session when needed, or hold in React state only.
  TOKEN_EXPIRY: 'tokenExpiry',
  ONBOARDING_COMPLETED: 'onboarding_completed',
  STAFF_ONBOARDED: 'staff_onboarded',
  USER_TYPE: 'userType',
  ORGANIZATION_ID: 'organizationId',
  ROLE: 'role',
  MEMBER_ID: 'memberId',
  THEME_MODE: 'theme-mode',
  REMEMBER_ME: 'rememberMe',
  AUTH_EVENT: '__ak_auth_event',  // cross-tab auth sync (storage event)
  // F8.2 — per-dentist preference for auto-opening the tooth chart at
  // visit mount. Default ON; flipped via the in-chart toggle pill.
  AUTO_OPEN_TOOTH_CHART: 'arogya:dentist-auto-open-tooth-chart',
  // F8.6 — once-dismissed marker for the "Start by clicking any tooth"
  // workflow hint banner that appears for patients with no findings.
  CHART_HINT_SEEN: 'arogya:chart-hint-seen',
};

// UI Constants
export const UI_CONSTANTS = {
  MAX_TEXTAREA_HEIGHT: 200,
  IMAGE_PREVIEW_SIZE: 88,
  LOGO_SIZE: 40,
  ICON_SIZE: 20,
  MIN_TAP_TARGET: 44,
};

// Animation & Timing
export const TIMING = {
  AUTO_SCROLL_DELAY: 100,
  RESIZE_DEBOUNCE: 150,
  THEME_TRANSITION: 300,
  SESSION_STABILIZATION_DELAY: 500,
  SESSION_CHECK_INTERVAL: 250,
  SESSION_MAX_ATTEMPTS: 20,
  SIGNOUT_WAIT: 300,
  RESEND_OTP_COOLDOWN: 45,
};

// Message Roles
export const MESSAGE_ROLES = {
  USER: 'user',
  AGENT: 'agent',
};

// File Upload
export const FILE_UPLOAD = {
  ACCEPTED_TYPES: 'image/*',
  MAX_FILES: 10,
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
};

// Error Messages
export const ERROR_MESSAGES = {
  SEND_ERROR: 'Sorry, I encountered an error. Please try again.',
  LOGOUT_ERROR: 'Error logging out. Please try again.',
  IMAGE_UPLOAD_ERROR: 'Failed to upload image. Please try again.',
  NETWORK_ERROR: 'Network error. Please check your connection.',
};
